import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import BoxContainer from '../BoxContainer/BoxContainer';
import { useForm, Controller } from 'react-hook-form';
import PhoneField from '../PhoneField/PhoneField';
import { setItem } from '../../utils/util';
import ErrorMessageInput from '../ErrorMessajeInput/ErrorMessageInput';
import * as APIUtil from '../../utils/service/service_api';
import { useClientByPhone } from '../../utils/service/service_user_api';
import Phone from '../../styles/assets/phone.png';
import css from '../../styles/modules/BoxContainer/createaccountfirststep.module.css';
import get from 'lodash/get';
import { BeatLoader } from 'react-spinners';

const Login = (props) => {
  const [phone_number, setPhoneNumber] = useState('');
  const [error, onSetError] = useState({ active: false, messageError: '' });
  const tenantId = get(props, 'tenant._id');
  const { errors, control, handleSubmit } = useForm();
  const { refetch: refetchNewClient } = useClientByPhone();
  const [loading, setLoading] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const accentColor = props.branding?.accentColor;
  const focusedBorder = `2px solid ${accentColor}`;
  const blurredBorder = `1px solid ${accentColor}`;
  const borderStyle = isFocused ? focusedBorder : blurredBorder;
  const [border5, setBorder5] = useState(
    `1px solid ${props.branding?.accentColor}`,
  );

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const phone = '+1' + phone_number.replace(/\D/g, '');

    refetchNewClient({ mobilePhone: phone })
      .then((response) => {
        setLoading(false);
        const client = response?.data?.client;

        if (client) {
          setItem('login_user', 'existing_user');
          getCode(tenantId, client?._id, client);
        } else {
          props.history.push('/create-account/', { state: 'NO_USER' });
        }
      })
      .catch((err) => {
        console.error('Error during refetch:', err);
        // Handle this error accordingly, maybe set an error state or show a message to user
      });
  };
  const getCode = (tenantId, clientid, client) => {
    APIUtil.getSMSCode(tenantId, clientid).then(() => {
      props.history.push('/create-account/account-verification', { client });
    });
  };

  const formatAsPhoneNumber = (input) => {
    const numericInput = input.replace(/\D/g, '');
    let formattedNumber = '';
    if (numericInput.length > 3) {
      const areaCode = numericInput.substring(0, 3);
      const prefix = numericInput.substring(3, 6);
      const lineNumber = numericInput.substring(6);
      formattedNumber = `(${areaCode}) ${prefix}-${lineNumber}`;
    } else {
      formattedNumber = numericInput;
    }
    return formattedNumber;
  };

  const handleInput = (e) => {
    if (formatAsPhoneNumber(phone_number).length <= 14) {
      setPhoneNumber(formatAsPhoneNumber(e.target.value));
    }
  };

  const handleFocus = () => {
    setBorder5(`2px solid ${props.branding?.accentColor}`);
  };

  const handleBlur = () => {
    setBorder5(`1px solid ${props.branding?.accentColor}`);
  };

  //for smooth deletion
  const handleKeyDown = (e) => {
    if (e.key === 'Backspace' && phone_number.length > 0) {
      // Remove the last character from phone_number
      setPhoneNumber(phone_number.slice(0, -1));

      // Prevent the default behavior of the Backspace key
      e.preventDefault();
    }
  };

  return (
    <BoxContainer withDoubleBorder withLogButton brandLogo>
      <form onSubmit={onSubmit}>
        <div className={css.checkYourPhoneWrapper}>
          <h1 className={css.checkYourPhone}>
            Please enter your mobile phone number.
          </h1>
        </div>

        <div className={css.subWrapper}>
          <div
            style={{
              boxShadow: `0vw 3px 3px ${props?.branding?.accentColor?.replace(
                /[\d.]+\)$/g,
                '0.25)',
              )}`,
            }}
            className={css.textFieldSub2}
          >
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>Mobile Phone</p>
                <input
                  // ref={formatAsPhoneNumber(phoneNumber).length <= 14 ?register({ required: true, maxLength: 14 }) : null}
                  value={phone_number}
                  className={css.textFieldSmall}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  onInput={handleInput}
                  onChange={handleInput}
                  onKeyDown={handleKeyDown}
                  style={{ border: border5, outline: 'none' }}
                  name="phone_number"
                  type="tel"
                  maxLength={14}
                  inputMode="tel"
                />
                <div className={css.advisoryStatement}>
                  <img src={Phone} className={css.mobilePhone} />
                  <p className={css.idText}>
                    Standard text messaging and provider rates may apply.
                  </p>
                </div>

                {errors.phone_number &&
                  errors.phone_number.type === 'required' && (
                    <ErrorMessageInput>This is required</ErrorMessageInput>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center mt-5">
          <button
            disabled={loading}
            type="submit"
            style={{ backgroundColor: props?.branding?.accentColor }}
            className={css.getStartedBtn}
          >
            {!loading ? (
              'Get Security Code'
            ) : (
              <BeatLoader size={8} color="white" />
            )}
          </button>
          <div className="ml-3">
            Return to{' '}
            <span
              className="create-account__paymints-link"
              onClick={() => props.history.push('/create-account')}
            >
              Register
            </span>
          </div>
        </div>
      </form>
    </BoxContainer>
  );
};

export default withRouter(Login);
